import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Wordmark } from '../components/Logo';
import { errorCopy } from '../lib/errors';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const res = await login({ email, password });
    setSubmitting(false);
    if (res.ok) navigate('/app', { replace: true });
    else setError(errorCopy(res.error));
  }

  return (
    <main className="min-h-screen flex flex-col items-center px-6 py-10">
      <Link to="/" className="mb-12">
        <Wordmark className="text-ink" />
      </Link>

      <div className="w-full max-w-md">
        <h1 className="text-3xl font-semibold tracking-tighter mb-2">
          Bienvenido de vuelta.
        </h1>
        <p className="text-ink/70 mb-8">Pasá, te estábamos esperando.</p>

        <form onSubmit={onSubmit} className="space-y-5">
          <label className="block">
            <span className="text-sm font-medium text-ink/80 mb-1.5 block">Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              className="w-full rounded-lg border border-ink/15 bg-white px-4 py-3 focus:border-forest focus:ring-2 focus:ring-forest/20 focus:outline-none"
            />
          </label>
          <label className="block">
            <span className="text-sm font-medium text-ink/80 mb-1.5 block">Contraseña</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="w-full rounded-lg border border-ink/15 bg-white px-4 py-3 focus:border-forest focus:ring-2 focus:ring-forest/20 focus:outline-none"
            />
          </label>

          {error && (
            <div className="text-sm text-danger bg-danger/5 border border-danger/20 rounded-lg px-4 py-3">
              {error}
            </div>
          )}

          <button type="submit" disabled={submitting} className="btn-primary w-full disabled:opacity-50">
            {submitting ? 'Bancá un toque…' : 'Entrar'}
          </button>
        </form>

        <p className="mt-6 text-sm text-ash text-center">
          ¿Todavía no tenés cuenta?{' '}
          <Link to="/signup" className="text-ink underline underline-offset-4">Probala gratis</Link>
        </p>
      </div>
    </main>
  );
}
